import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from 'primeng/button';
import {Message} from '../../contracts/message.interface';
import {Conversation} from '../../contracts/conversation.interface';
import {MessageRendererComponent} from '../message/message-renderer/message-renderer.component';
import {ContactDisplayPipe} from '../../../shared/pipes/contact-display.pipe';

@Component({
  selector: 'app-chat-reply-context',
  imports: [MessageRendererComponent],
  templateUrl: './chat-reply-context.component.html',
  styleUrl: './chat-reply-context.component.scss'
})
export class ChatReplyContextComponent {
  @Input() replyMessage?: Message;
  @Input() conversation?: Conversation;
  @Output() clearReply = new EventEmitter<void>();

  get senderLabel(): string {
    if (!this.replyMessage) return '';
    if (this.replyMessage.type === 'S') return 'Tu';
    const pipe = new ContactDisplayPipe();
    return pipe.transform(this.conversation?.contact, this.conversation?.fromNumber ?? '');
  }

  get isSelf(): boolean {
    return this.replyMessage?.type === 'S';
  }

  onClear() {
    this.clearReply.emit();
  }
}
